angular.module('impactx.deliverynote').controller('DeliveryNoteListCtrl', [
    'selectedListItems',
    '$redirect',
    DeliveryNoteListCtrl
]);

function DeliveryNoteListCtrl(selectedListItems, $redirect) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: canViewDeliveryNote,
            process: 'DeliveryNote'
        },
        {
            label: "details",
            linkFunction: getEditLink,
            type: 'link',
            condition: canEditDeliveryNote,
            process: 'DeliveryNote'
        },
        {
            label: "match",
            action: redirectToMatchList,
            condition: canMatch,
            process: 'AcceptUnmatchedInvoice'
        },
        {
            label: "invalidDNH",
            linkFunction: getInvalidDNHLink,
            type: 'link',
            condition: selectedListItems.isNoSelection,
            process: 'InvalidDeliveryNote'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/deliverynote/templates/deliverynotelist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/deliverynote/list',
        ctrl: this,
        id: "deliverynote",
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "deliverynotedetail/" + selectedListItems.getFirstSelectedId();
    }

    function getEditLink() {
        return "deliverynote/edit/" + selectedListItems.getFirstSelectedId();
    }

    function getInvalidDNHLink() {
        return "invaliddeliverynotelist";
    }

    function canViewDeliveryNote() {
        return selectedListItems.isSingleSelection() && !selectedListItems.getFirstSelectedItem().canEdit.value;
    }

    function canEditDeliveryNote() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canEdit.value;
    }

    function redirectToMatchList () {
        $redirect.redirectTo(null, "/invoice/acceptedunmatched/", selectedListItems.getSelectedIds());
    }

    function canMatch () {
        return selectedListItems.checkEach(function (item) {
            return item.canMatchAcceptedInvoice && item.canMatchAcceptedInvoice.value;
        });
    }
}
